import React, { useState } from 'react'
import { createContainer } from 'unstated-next'

const UseDashboardAdminStore = () => {
  return {}
}

export default createContainer(UseDashboardAdminStore)
